import { render, staticRenderFns } from "./nhs-bereavement.html?vue&type=template&id=2c898383&"
import script from "./nhs-bereavement.js?vue&type=script&lang=js&"
export * from "./nhs-bereavement.js?vue&type=script&lang=js&"
import style0 from "./nhs-bereavement.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports